module.exports = __webpack_public_path__ + "res/landing_ar.c6e6ef155b5d63d2077f6aace8fdf167.mp4";